import React from 'react'
import { FilterNodeConfig } from '../nodes/types'
import { FilterNodeConfigForm } from './FilterNodeConfigForm'

interface Props {
  nodeId: string
  config: FilterNodeConfig
  onChange: (config: FilterNodeConfig) => void
}

export const SelectorNodeConfigForm: React.FC<Props> = props => (
  <FilterNodeConfigForm {...props} variant="selector" />
)
